import type { DayItem } from "@/utils/models";

/** Everyone the days name: their shifts, punches and time off. The people the Week view's staff search lists and finds. */
export const weekPersonIdsOf = (days: readonly DayItem[]): Set<number> =>
	new Set(
		days.flatMap((day) => [
			...day.shifts.map((shift) => shift.nurseId),
			...day.shiftsActual.map((shift) => shift.nurseId),
			...day.pto.map((preference) => preference.nurse_id),
		]),
	);
